import axios from 'axios';
import DashboardLayout from '../layout/DashboardLayout.vue'
import SiteLayout from '../layout/SiteLayout.vue'
import CidadaoLayout from '../layout/CidadaoLayout.vue'
// GeneralViews
import NotFound from '../pages/NotFoundPage.vue'

//site 
import Home from 'src/pages/Site/Home.vue'
import RealizarManifestacao from 'src/pages/Site/RealizarManifestacao.vue'
import RegistrarCidadao from 'src/pages/Site/RegistrarCidadao.vue'
import MostrarRegistro from 'src/pages/Site/RegistroResposta.vue'
import LoginCidadao from 'src/pages/Site/LoginCidadao.vue'
import EsqueceuSenha from 'src/pages/Site/EsqueceuSenha.vue'
import TrocadeSenhaLogin from 'src/pages/Site/TrocadeSenhaLogin.vue'
import AtivarConta from 'src/pages/Site/AtivarConta.vue'

// Admin pages
import Login from 'src/pages/Sistema/Login.vue'
import Overview from 'src/pages/Sistema/Overview.vue'
import Manifestacao from 'src/pages/Sistema/manifestacao/Manifestacao.vue'
import ConversaManifestacao from 'src/pages/Sistema/manifestacao/ConversaManifestacao.vue'
import TransferirManifestacao from 'src/pages/Sistema/manifestacao/TransferirManifestacao.vue'
import Usuario from 'src/pages/Sistema/usuario/Usuario.vue'
import UsuarioEditar from 'src/pages/Sistema/usuario/UsuarioEditar.vue'
import UsuarioCadastrar from 'src/pages/Sistema/usuario/UsuarioCadastrar.vue'
import Permissao from 'src/pages/Sistema/grupo/Permissao.vue'
import PermissaoCadastrar from 'src/pages/Sistema/grupo/PermissaoCadastrar.vue'
import PermissaoEditar from 'src/pages/Sistema/grupo/PermissaoEditar.vue'
import Cidadao from 'src/pages/Sistema/cidadao/Cidadao.vue'
import CidadaoEditar from 'src/pages/Sistema/cidadao/CidadaoEditar.vue'
import Departamento from 'src/pages/Sistema/unidade/Departamentos.vue'
import DepartamentoCadastro from 'src/pages/Sistema/unidade/DepartamentosCadastro.vue'
import DepartamentoEditar from 'src/pages/Sistema/unidade/DepartamentosEditar.vue'
import Assunto from 'src/pages/Sistema/assunto/Assuntos.vue'
import AssuntosCadastro from 'src/pages/Sistema/assunto/AssuntosCadastro.vue'
import AssuntosEditar from 'src/pages/Sistema/assunto/AssuntosEditar.vue'
import Perfil from 'src/pages/Sistema/perfil/Perfil.vue'
import LogGeral from 'src/pages/Sistema/log/LogGeral.vue'
import LogCidadao from 'src/pages/Sistema/log/LogCidadao.vue'
import LogManifestacao from 'src/pages/Sistema/log/LogManifestacao.vue'
import LogMovManifestacao from 'src/pages/Sistema/log/LogMovManifestacao.vue'
import FormOuvidorManifestacao from 'src/pages/Sistema/formularios/OuvidorManifestacao.vue'

//cidadao sistema
import OverviewCidadao from 'src/pages/Cidadao/Overview.vue'
import ManifestacaoEspera from 'src/pages/Cidadao/ManifestacaoEspera.vue'
import ManifestacaoMinha from 'src/pages/Cidadao/ManifestacaoMinha.vue'
import ConversaManifestacaoCid from 'src/pages/Cidadao/ConversaManifestacao.vue'
import MeuPerfil from 'src/pages/Cidadao/MeuPerfil.vue'
import EnviarSenha from 'src/pages/Cidadao/EnviarSenhaNova.vue'

import 'src/controller/loginController.js'
import store from "src/store.js"
import store_cidadao from "src/storeCidadao.js"

const token = sessionStorage.getItem("token");
const header = {
  headers:{
    'Content-Type': 'application/json',
    'Access-Control-Allow-Origin': '*',
    'Access-Control-Allow-Methods': 'GET, POST, PUT, DELETE, OPTIONS',
    'Authorization': 'Bearer '+ token,
   }
}

const WhoIam = async (token) => {
  try {
    let res = await axios.post('/auth/whoiam');
    return res.data;
  } catch (e) {
    throw e;
  }
}

const Me = async (token)=> {
  try {
    let res = await axios.post('auth/me', {});
    return res.data;
  } catch (e) {
    throw e;
  }
}

const MeCidadao = async () => {
  try {
    let res = await axios.post('auth/meCidadao');
    return res.data;
  } catch (e) {
    throw e;
  }
}

const Logout = async (token) => {
  try {
    let res = await axios.post('auth/logout');
    return res.data;
  } catch (e) {
    throw e;
  }
}


const suaPermissao = async (token,id) => {
  try {
    let res = await axios.get('permissao/'+id+'/user', {});
    return res.data;
  } catch (e) {
    throw e;
  }
}

const usuarioCidadao = async (me) =>{
  try {
    store_cidadao.email = me.email;
    store_cidadao.nome = me.name;
    store_cidadao.id_cidadao = me.id_cidadao;
    store_cidadao.status = me.status;
    return store_cidadao;
  } catch (e) {
    throw e;
  }
}

const usuarioSistema = async (me) =>{
  try {
    store.departamento = me.departamento;
    store.grupo = me.grupo;
    store.id = me.id;
    store.tipo = me.tipo;
    return store;
  } catch (e) {
    throw e;
  }
}

const acessoSistema = async (data) =>{
  try {
    if (data.admin == true) {
      // sendo super administrador ele acessa a rota
      store.admin = true;
      store.admin_sistema = false;
      store.cidadao = false;
      return true;

    }else if (data.admin_sistema == true) {
      // sendo administrador ele acessa a rota
      store.admin = false;
      store.admin_sistema = true;
      store.cidadao = false;
      return true;

    }else if(data.cidadao == true){
      return false;
    }

  } catch (e) {
    throw e;
  }
}

const acessoCidadao = async (data) =>{
  try {
    if(data.cidadao == true){
      store.admin = false;
      store.admin_sistema = false;
      store.cidadao = true;
      return true;
    }else if (data.admin == true) {
      // sendo super administrador ele acessa a rota
      return false;

    }else if (data.admin_sistema == true) {
      // sendo administrador ele acessa a rota
      return false;
    }

  } catch (e) {
    throw e;
  }
}

const routes = [

  /**
   * 
   * Site 'Publica'
   * 
  **/

  {
    path: '/',
    component:SiteLayout,
    redirect:'/home',
    children: [
      {
        path: 'home',
        name: 'home',
        component: Home
      },
      {
        path: 'manifestacao',
        name: 'realizarManifestacao',
        component:RealizarManifestacao,
        props: true,
      },
      {
        path: 'registro',
        name: 'registroCidadao',
        component:RegistrarCidadao
      },
      {
        path: 'visualizarRegistro',
        name: 'registromostrar',
        props: true,
        component: MostrarRegistro,       
      },
      {
        path: 'login',
        name: 'loginCidadao',
        props:true,
        component:LoginCidadao
      },
      {
        path: 'login/esqueceusenha',
        name: 'loginesqueceusenha',
        component:EsqueceuSenha
      },
      {
        path: 'login/v1/novasenha/usuario/:email/:token/:nome',
        name: 'novasenhalogin',
        props:true,
        component:TrocadeSenhaLogin
      },
      {
        path: 'login/v1/ativar/conta/:email/:token',
        name: 'ativarconta',
        props:true,
        component:AtivarConta
      }
    ]
  },

  /**
   * 
   * 'Cidadao'
   * 
  **/

  {
    path: '/painelcidadao',
    name: 'painelcidadao',
    component: CidadaoLayout,
    redirect: '/painelcidadao/home',
    children: [
      {
        path: 'home',
        name: 'cidadaohome',
        component: OverviewCidadao,
        beforeEnter: async (to, from, next) => {
          try {
            let data = await WhoIam(token); 
            let me = await MeCidadao(token);
            let logout;

            if(me.status){
              let acesso = await acessoCidadao(data);

              if(acesso){
                await usuarioCidadao(me);
                return next()
              }else{
                next(false);
                logout = await Logout(token);
                next('/login');
                location.reload();
              }
            }else{
              next(false);
              logout = await Logout(token);
              next({
                 path:'/login',
              });
              alert('Cidadão precisa ser Ativado!');
              grecaptcha.reset();
              //location.reload();
            }

          }catch(e){
             // caso nao tenha acesso ou esteja deslogado ele volta pro login
             next('/login');
          }
        }
      },
      {
        path: 'espera',
        name: 'manifestoespera',
        props: true,
        component: ManifestacaoEspera,
        beforeEnter: async (to, from, next) => {
          try {
            let data = await WhoIam(token); 
            let me = await MeCidadao(token);
            let logout;
            let acesso = await acessoCidadao(data);

            if(me.status){
              let acesso = await acessoCidadao(data);

              if(acesso){
                await usuarioCidadao(me);
                return next()
              }else{
                next(false);
                logout = await Logout(token);
                next('/login');
                location.reload();
              }
            }else{
              next(false);
              logout = await Logout(token);
              next({
                 path:'/login',
              });
              alert('Cidadão precisa ser Ativado!');
              grecaptcha.reset();
              //location.reload();
            }
          }catch(e){
             // caso nao tenha acesso ou esteja deslogado ele volta pro login
             next('/login');
          }
        }
      },
      {
        path: 'respostas',
        name: 'conversasCid',
        props: true,
        component: ConversaManifestacaoCid,
        beforeEnter: async (to, from, next) => {
          try {
            let data = await WhoIam(token); 
            let me = await MeCidadao(token);
            let logout;
            let acesso = await acessoCidadao(data);

            if(me.status){
              let acesso = await acessoCidadao(data);

              if(acesso){
                await usuarioCidadao(me);
                return next()
              }else{
                next(false);
                logout = await Logout(token);
                next('/login');
                location.reload();
              }
            }else{
              next(false);
              logout = await Logout(token);
              next({
                 path:'/login',
              });
              alert('Cidadão precisa ser Ativado!');
              grecaptcha.reset();
              //location.reload();
            }
          }catch(e){
             // caso nao tenha acesso ou esteja deslogado ele volta pro login
             next('/login');
          }
        }
      },
      {
        path: 'minhasmanifestacoes',
        name: 'minhasmanifestacoes',
        props: true,
        component: ManifestacaoMinha,
        beforeEnter: async (to, from, next) => {
          try {
            let data = await WhoIam(token); 
            let me = await MeCidadao(token);
            let logout;
            let acesso = await acessoCidadao(data);

            if(me.status){
              let acesso = await acessoCidadao(data);

              if(acesso){
                await usuarioCidadao(me);
                return next()
              }else{
                next(false);
                logout = await Logout(token);
                next('/login');
                location.reload();
              }
            }else{
              next(false);
              logout = await Logout(token);
              next({
                 path:'/login',
              });
              alert('Cidadão precisa ser Ativado!');
              grecaptcha.reset();
              //location.reload();
            }
          }catch(e){
             // caso nao tenha acesso ou esteja deslogado ele volta pro login
             next('/login');
          }
        }
      },
      {
        path: 'perfil',
        name: 'meuperfil',
        props: true,
        component: MeuPerfil,
        beforeEnter: async (to, from, next) => {
          try {
            let data = await WhoIam(token); 
            let me = await MeCidadao(token);
            let logout;
            let acesso = await acessoCidadao(data);

            if(me.status){
              let acesso = await acessoCidadao(data);

              if(acesso){
                await usuarioCidadao(me);
                return next()
              }else{
                next(false);
                logout = await Logout(token);
                next('/login');
                location.reload();
              }
            }else{
              next(false);
              logout = await Logout(token);
              next({
                 path:'/login',
              });
              alert('Cidadão precisa ser Ativado!');
              grecaptcha.reset();
              //location.reload();
            }
          }catch(e){
             // caso nao tenha acesso ou esteja deslogado ele volta pro login
             next('/login');
          }
        }
      },
      {
        path: 'enviarsenha',
        name: 'enviarsenha',
        props: true,
        component: EnviarSenha,
        beforeEnter: async (to, from, next) => {
          try {
            let data = await WhoIam(token); 
            let me = await MeCidadao(token);
            let logout;
            let acesso = await acessoCidadao(data);

            if(me.status){
              let acesso = await acessoCidadao(data);

              if(acesso){
                await usuarioCidadao(me);
                return next()
              }else{
                next(false);
                logout = await Logout(token);
                next('/login');
                location.reload();
              }
            }else{
              next(false);
              logout = await Logout(token);
              next({
                 path:'/login',
              });
              alert('Cidadão precisa ser Ativado!');
              grecaptcha.reset();
              //location.reload();
            }
          }catch(e){
             // caso nao tenha acesso ou esteja deslogado ele volta pro login
             next('/login');
          }
        }
      }
      
    ]
  },

  /**
   * 
   * Sistema  'Privado'
   * 
  **/
  {
    path: '/sistema',
    redirect: '/sistema/login'
  },
  {
    path: '/sistema/login',
    name:'login',
    component: Login, 
  },
  {
    path: '/sistema',
    component: DashboardLayout,
    beforeEnter: async (to, from, next) => {
      let me = await Me(token);
      store.id = me.id;
      store.departamento = me.departamento;
      return next();
    },
    redirect: '/sistema/overview',
    children: [
      {
        path: 'overview',
        name: 'Overview',
        component: Overview,
        beforeEnter: async (to, from, next) => {
          try {
            let data = await WhoIam(token);
            let me = await Me(token);
            let logout;
            let acesso = await acessoSistema(data);

            if(acesso){
              await usuarioSistema(me);
              return next();
            }else{
              next(false);
              logout = await Logout(token);
              next('/sistema/login');
            }
          }catch(e){
             // caso nao tenha acesso ou esteja deslogado ele volta pro login
             next('/sistema/login');
          }
        }
      },
      {
        path: 'manifestacao',
        name: 'manifestacao',
        component: Manifestacao,

        beforeEnter: async (to, from, next) => {
          try {
            let data = await WhoIam(token);
            let me = await Me(token);
            let logout;
            let acesso = await acessoSistema(data);

            if(acesso){
              await usuarioSistema(me);
              return next();
            }else{
              next(false);
              logout = await Logout(token);
              next('/sistema/login');
            }
          }catch(e){
             // caso nao tenha acesso ou esteja deslogado ele volta pro login
             next('/sistema/login');
          }
        }
      },
      {
        path: 'cidadaos',
        name: 'cidadaos',
        component: Cidadao,

        beforeEnter: async (to, from, next) => {
          try {
            let data = await WhoIam(token);
            let me = await Me(token);
            let logout;
            let acesso = await acessoSistema(data);

            if(acesso){
              await usuarioSistema(me);
              return next();
            }else{
              next(false);
              logout = await Logout(token);
              next('/sistema/login');
            }
          }catch(e){
             // caso nao tenha acesso ou esteja deslogado ele volta pro login
             next('/sistema/login');
          }
        }
      },
      {
        path: 'cidadao',
        name: 'cidadao',
        props: true,
        component: CidadaoEditar,

        beforeEnter: async (to, from, next) => {
          try {
            let data = await WhoIam(token);
            let me = await Me(token);
            let logout;
            let acesso = await acessoSistema(data);

            if(acesso){
              await usuarioSistema(me);
              return next();
            }else{
              next(false);
              logout = await Logout(token);
              next('/sistema/login');
            }
          }catch(e){
             // caso nao tenha acesso ou esteja deslogado ele volta pro login
             next('/sistema/login');
          }
        }
      },
      {
        path: 'usuario',
        name: 'usuario',
        component: Usuario,
        beforeEnter: async (to, from, next) => {
          try {
            let data = await WhoIam(token);
            let me = await Me(token);
            let logout;
            let acesso = await acessoSistema(data);

            if(acesso){
              await usuarioSistema(me);
              return next();
            }else{
              next(false);
              logout = await Logout(token);
              next('/sistema/login');
            }
          }catch(e){
             // caso nao tenha acesso ou esteja deslogado ele volta pro login
             next('/sistema/login');
          }
        }
        
      },
      {
        path: 'usuarioEditar',
        name: 'usuarioEditar',
        props: true,
        component: UsuarioEditar,

        beforeEnter: async (to, from, next) => {
          try {
            let data = await WhoIam(token);
            let me = await Me(token);
            let logout;
            let acesso = await acessoSistema(data);

            if(acesso){
              await usuarioSistema(me);
              return next();
            }else{
              next(false);
              logout = await Logout(token);
              next('/sistema/login');
            }
          }catch(e){
             // caso nao tenha acesso ou esteja deslogado ele volta pro login
             next('/sistema/login');
          }
        }
       
      },
      {
        path: 'usuarioCadastro',
        name: 'usuarioCadastrar',
        props: true,
        component: UsuarioCadastrar,
        beforeEnter: async (to, from, next) => {
          try {
            let data = await WhoIam(token);
            let me = await Me(token);
            let logout;
            let acesso = await acessoSistema(data);

            if(acesso){
              await usuarioSistema(me);
              return next();
            }else{
              next(false);
              logout = await Logout(token);
              next('/sistema/login');
            }
          }catch(e){
             // caso nao tenha acesso ou esteja deslogado ele volta pro login
             next('/sistema/login');
          }
        }
       
      },
      
      {
        path: 'Manifestacao/start',
        name: 'Conversa',
        props: true,
        component: ConversaManifestacao,
        beforeEnter: async (to, from, next) => {
          try {
            let data = await WhoIam(token);
            let me = await Me(token);
            let logout;
            let acesso = await acessoSistema(data);

            if(acesso){
              await usuarioSistema(me);
              return next();
            }else{
              next(false);
              logout = await Logout(token);
              next('/sistema/login');
            }
          }catch(e){
             // caso nao tenha acesso ou esteja deslogado ele volta pro login
             next('/sistema/login');
          }
        }
        
      },
      {
        path: 'Manifestacao/transferencia',
        name: 'transferirManifestacao',
        props: true,
        component:TransferirManifestacao,
        beforeEnter: async (to, from, next) => {
          try {
            let data = await WhoIam(token);
            let me = await Me(token);
            let logout;
            let acesso = await acessoSistema(data);

            if(acesso){
              await usuarioSistema(me);
              return next();
            }else{
              next(false);
              logout = await Logout(token);
              next('/sistema/login');
            }
          }catch(e){
             // caso nao tenha acesso ou esteja deslogado ele volta pro login
             next('/sistema/login');
          }
        }
        
      },
      {
        path: 'departamentos',
        name: 'departamentos',
        component:Departamento,
        beforeEnter: async (to, from, next) => {
          try {
            let data = await WhoIam(token);
            let me = await Me(token);
            let logout;
            let acesso = await acessoSistema(data);

            if(acesso){
              await usuarioSistema(me);
              return next();
            }else{
              next(false);
              logout = await Logout(token);
              next('/sistema/login');
            }
          }catch(e){
             // caso nao tenha acesso ou esteja deslogado ele volta pro login
             next('/sistema/login');
          }
        }
       
      },
      {
        path: 'departamento/cadastro',
        name: 'departamentocadastro',
        component:DepartamentoCadastro,
        beforeEnter: async (to, from, next) => {
          try {
            let data = await WhoIam(token);
            let me = await Me(token);
            let logout;
            let acesso = await acessoSistema(data);

            if(acesso){
              await usuarioSistema(me);
              return next();
            }else{
              next(false);
              logout = await Logout(token);
              next('/sistema/login');
            }
          }catch(e){
             // caso nao tenha acesso ou esteja deslogado ele volta pro login
             next('/sistema/login');
          }
        }
        
      },
      {
        path: 'departamento/edit',
        name: 'departamentoeditar',
        props: true,
        component:DepartamentoEditar,
        beforeEnter: async (to, from, next) => {
          try {
            let data = await WhoIam(token);
            let me = await Me(token);
            let logout;
            let acesso = await acessoSistema(data);

            if(acesso){
              await usuarioSistema(me);
              return next();
            }else{
              next(false);
              logout = await Logout(token);
              next('/sistema/login');
            }
          }catch(e){
             // caso nao tenha acesso ou esteja deslogado ele volta pro login
             next('/sistema/login');
          }
        }
        
      },
      {
        path: 'permissao',
        name: 'permissao',
        component:Permissao,
        beforeEnter: async (to, from, next) => {
          try {
            let data = await WhoIam(token);
            let me = await Me(token);
            let logout;
            let acesso = await acessoSistema(data);

            if(acesso){
              await usuarioSistema(me);
              return next();
            }else{
              next(false);
              logout = await Logout(token);
              next('/sistema/login');
            }
          }catch(e){
             // caso nao tenha acesso ou esteja deslogado ele volta pro login
             next('/sistema/login');
          }
        }
        
      },
      {
        path: 'permissao/cadastro',
        name: 'permissaocadastro',
        component:PermissaoCadastrar,
        beforeEnter: async (to, from, next) => {
          try {
            let data = await WhoIam(token);
            let me = await Me(token);
            let logout;
            let acesso = await acessoSistema(data);

            if(acesso){
              await usuarioSistema(me);
              return next();
            }else{
              next(false);
              logout = await Logout(token);
              next('/sistema/login');
            }
          }catch(e){
             // caso nao tenha acesso ou esteja deslogado ele volta pro login
             next('/sistema/login');
          }
        }
        
      },
      {
        path: 'permissao/editar',
        name: 'permissaoeditar',
        props: true,
        component: PermissaoEditar,
        beforeEnter: async (to, from, next) => {
          try {
            let data = await WhoIam(token);
            let me = await Me(token);
            let logout;
            let acesso = await acessoSistema(data);

            if(acesso){
              await usuarioSistema(me);
              return next();
            }else{
              next(false);
              logout = await Logout(token);
              next('/sistema/login');
            }
          }catch(e){
             // caso nao tenha acesso ou esteja deslogado ele volta pro login
             next('/sistema/login');
          }
        }
       
      },
      {
        path: 'assuntos',
        name: 'assuntos',
        component:Assunto,
        beforeEnter: async (to, from, next) => {
          try {
            let data = await WhoIam(token);
            let me = await Me(token);
            let logout;
            let acesso = await acessoSistema(data);

            if(acesso){
              await usuarioSistema(me);
              return next();
            }else{
              next(false);
              logout = await Logout(token);
              next('/sistema/login');
            }
          }catch(e){
             // caso nao tenha acesso ou esteja deslogado ele volta pro login
             next('/sistema/login');
          }
        }
       
      },
      {
        path: 'assunto/cadastro',
        name: 'assuntocadastro',
        component:AssuntosCadastro,
        beforeEnter: async (to, from, next) => {
          try {
            let data = await WhoIam(token);
            let me = await Me(token);
            let logout;
            let acesso = await acessoSistema(data);

            if(acesso){
              await usuarioSistema(me);
              return next();
            }else{
              next(false);
              logout = await Logout(token);
              next('/sistema/login');
            }
          }catch(e){
             // caso nao tenha acesso ou esteja deslogado ele volta pro login
             next('/sistema/login');
          }
        }
        
      },
      {
        path: 'assunto/edit',
        name: 'assuntoeditar',
        props: true,
        component:AssuntosEditar,
        beforeEnter: async (to, from, next) => {
          try {
            let data = await WhoIam(token);
            let me = await Me(token);
            let logout;
            let acesso = await acessoSistema(data);

            if(acesso){
              await usuarioSistema(me);
              return next();
            }else{
              next(false);
              logout = await Logout(token);
              next('/sistema/login');
            }
          }catch(e){
             // caso nao tenha acesso ou esteja deslogado ele volta pro login
             next('/sistema/login');
          }
        }
        
      },
      {
        path: 'meuperfil',
        name: 'perfil',
        component:Perfil,
        beforeEnter: async (to, from, next) => {
          try {
            let data = await WhoIam(token);
            let me = await Me(token);
            let logout;
            let acesso = await acessoSistema(data);

            if(acesso){
              await usuarioSistema(me);
              return next();
            }else{
              next(false);
              logout = await Logout(token);
              next('/sistema/login');
            }
          }catch(e){
             // caso nao tenha acesso ou esteja deslogado ele volta pro login
             next('/sistema/login');
          }
        }
        
      },
      {
        path: 'log_geral',
        name: 'logGeral',
        component:LogGeral,
        beforeEnter: async (to, from, next) => {
          try {
            let data = await WhoIam(token);
            let me = await Me(token);
            let logout;
            let acesso = await acessoSistema(data);

            if(acesso){
              await usuarioSistema(me);
              return next();
            }else{
              next(false);
              logout = await Logout(token);
              next('/sistema/login');
            }
          }catch(e){
             // caso nao tenha acesso ou esteja deslogado ele volta pro login
             next('/sistema/login');
          }
        }
        
      },
      {
        path: 'log_cidadao',
        name: 'logCidadao',
        component:LogCidadao,
        beforeEnter: async (to, from, next) => {
          try {
            let data = await WhoIam(token);
            let me = await Me(token);
            let logout;
            let acesso = await acessoSistema(data);

            if(acesso){
              await usuarioSistema(me);
              return next();
            }else{
              next(false);
              logout = await Logout(token);
              next('/sistema/login');
            }
          }catch(e){
             // caso nao tenha acesso ou esteja deslogado ele volta pro login
             next('/sistema/login');
          }
        }
        
      },
      {
        path: 'log_manifestacao',
        name: 'logManifestacao',
        component:LogManifestacao,
        beforeEnter: async (to, from, next) => {
          try {
            let data = await WhoIam(token);
            let me = await Me(token);
            let logout;
            let acesso = await acessoSistema(data);

            if(acesso){
              await usuarioSistema(me);
              return next();
            }else{
              next(false);
              logout = await Logout(token);
              next('/sistema/login');
            }
          }catch(e){
             // caso nao tenha acesso ou esteja deslogado ele volta pro login
             next('/sistema/login');
          }
        }
       
      },
      {
        path: 'log_mov_manifestacao',
        name: 'logMovManifestacao',
        component: LogMovManifestacao,
        beforeEnter: async (to, from, next) => {
          try {
            let data = await WhoIam(token);
            let me = await Me(token);
            let logout;
            let acesso = await acessoSistema(data);

            if(acesso){
              await usuarioSistema(me);
              return next();
            }else{
              next(false);
              logout = await Logout(token);
              next('/sistema/login');
            }
          }catch(e){
             // caso nao tenha acesso ou esteja deslogado ele volta pro login
             next('/sistema/login');
          }
        }
        
      },
      {
        path: 'formulario_manifestacao',
        name: 'formOuvidorManif',
        component: FormOuvidorManifestacao,
        beforeEnter: async (to, from, next) => {
          try {
            let data = await WhoIam(token);
            let me = await Me(token);
            let logout;
            let acesso = await acessoSistema(data);

            if(acesso){
              await usuarioSistema(me);
              return next();
            }else{
              next(false);
              logout = await Logout(token);
              next('/sistema/login');
            }
          }catch(e){
             // caso nao tenha acesso ou esteja deslogado ele volta pro login
             next('/sistema/login');
          }
        }
        
      }
    ]
  },
  { path: '*', component: NotFound }
]

/**
 * Asynchronously load view (Webpack Lazy loading compatible)
 * The specified component must be inside the Views folder
 * @param  {string} name  the filename (basename) of the view to load.
function view(name) {
   var res= require('../components/Dashboard/Views/' + name + '.vue');
   return res;
};**/

export default routes
